<script>
// Demo-instance home page (local to /root/demo-instance, never pushed) — v5 (2026-09-24): the FIRST layout the user
// liked (v1: full-width hero + quick access overlapping it + promotions/news + services + key figures + footer),
// key-figures band removed (user); restyled modern in shades of the theme PRIMARY colour #1b6e5a (user, 2026-09-24); light bands, no dark ones.
// History: v1 marketing (layout kept here), v2 bento green/orange, v3 minimal, v4 bento ink/teal.
import Layout from "../../layouts/main";
import BannerApi from "@/services/banner-api";
import AnnouncementsApi from "@/services/announcements-api";

export default {
  components: { Layout },
  data() {
    return {
      bannerList: [],
      news: [],
      quick: [
        { icon: "bx-search-alt", title: "Catalogue", text: "Prix et disponibilités en temps réel", to: "/catalogue" },
        { icon: "bx-cart-alt", title: "Commander", text: "Panier, import de fichier, saisie rapide", to: "/catalogue" },
        { icon: "bx-receipt", title: "Commandes & documents", text: "Suivi, BL, factures et échéances", to: "/commandes" },
        { icon: "bx-support", title: "Réclamations", text: "Déclarez et suivez vos demandes", to: "/claim" },
        { icon: "bx-bar-chart-alt-2", title: "Rapports", text: "Achats, remises et statistiques", to: "/reporting" },
        { icon: "bx-purchase-tag-alt", title: "Promotions", text: "Offres et nouveautés du moment", to: "#actualites" },
      ],
      services: [
        { icon: "bx-time-five", title: "Catalogue en temps réel", text: "Stock, prix nets et remises à jour à chaque recherche." },
        { icon: "bxs-truck", title: "Livraison rapide", text: "Tournées quotidiennes, suivi de la préparation jusqu'à la livraison." },
        { icon: "bx-spa", title: "Pharmacie & parapharmacie", text: "Médicaments, dermo-cosmétique, hygiène, nutrition et matériel." },
        { icon: "bx-wallet", title: "Suivi financier", text: "Factures, avoirs, relevés et échéances accessibles en un clic." },
      ],
    };
  },
  mounted() {
    BannerApi.getBanners(window.innerWidth).then((r) => { this.bannerList = r || []; });
    AnnouncementsApi.getPromotionsAndNews(1, 3).then((r) => { this.news = (r && r.list ? r.list : []).slice(0, 3); });
  },
  methods: {
    go(to) {
      if (to.startsWith("#")) {
        const el = document.querySelector(to);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      } else if (this.$route.path !== to) {
        this.$router.push(to);
      }
    },
    fmtDate(d) {
      if (!d) return "";
      const x = new Date(d);
      return isNaN(x) ? "" : x.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
    },
    tagOf(a) {
      return a.tag || ({ 0: "Promo", 1: "Actualité", 2: "Nouveauté" })[a.type] || "Info";
    },
  },
};
</script>

<template>
  <Layout>
    <div class="lp">
      <!-- Hero -->
      <section class="lp-hero">
        <b-carousel class="lp-carousel" :interval="6000" :controls="false" :indicators="bannerList.length > 1" fade>
          <b-carousel-slide v-for="banner in bannerList" :key="banner.id">
            <template #img><img :src="'/api/banner/get/' + banner.generatedName" alt="" class="lp-hero-img" /></template>
          </b-carousel-slide>
          <b-carousel-slide v-if="!bannerList.length">
            <template #img><div class="lp-hero-img lp-hero-fallback"></div></template>
          </b-carousel-slide>
        </b-carousel>

        <div class="lp-hero-cap">
          <span class="lp-glass"><span class="lp-dot"></span>Grossiste répartiteur · Pharmacie &amp; parapharmacie</span>
          <h1>Votre approvisionnement,<br /><span class="lp-grad">en quelques clics.</span></h1>
          <p>Catalogue, prix et stock en temps réel, commandes 24h/24 et suivi jusqu'à la livraison.</p>
          <div class="lp-cta">
            <a href="/catalogue" class="lp-btn lp-btn-teal" @click.prevent="go('/catalogue')">
              Commander maintenant <i class="bx bx-right-arrow-alt"></i>
            </a>
            <a href="/commandes" class="lp-btn lp-btn-glass" @click.prevent="go('/commandes')">Mes commandes</a>
          </div>
        </div>
      </section>

      <!-- Quick access -->
      <section class="lp-wrap lp-quick">
        <a v-for="q in quick" :key="q.title" :href="q.to" class="lp-quick-card" @click.prevent="go(q.to)">
          <span class="lp-quick-icon"><i :class="['bx', q.icon]"></i></span>
          <span class="lp-quick-title">{{ q.title }}</span>
          <span class="lp-quick-text">{{ q.text }}</span>
        </a>
      </section>

      <!-- Promotions & news -->
      <section id="actualites" class="lp-wrap lp-section" v-if="news.length">
        <div class="lp-head">
          <span class="lp-kicker">À la une</span>
          <h2>Promotions &amp; actualités</h2>
        </div>
        <div class="lp-news">
          <article v-for="a in news" :key="a.id" class="lp-news-card">
            <div class="lp-news-img"><img v-if="a.image" :src="'/api/image/get/' + a.image" alt="" /></div>
            <div class="lp-news-body">
              <div class="lp-news-meta">
                <span :class="['lp-tag', 't' + a.type]">{{ tagOf(a) }}</span>
                <span class="lp-date">{{ fmtDate(a.date) }}</span>
              </div>
              <h3>{{ a.title }}</h3>
              <p>{{ a.description }}</p>
            </div>
          </article>
        </div>
      </section>

      <!-- Services -->
      <section class="lp-services-bg">
        <div class="lp-wrap lp-services">
          <div class="lp-services-img">
            <img src="@/assets/images/demo-services-officine.jpg" alt="Officine moderne" />
            <div class="lp-badge"><span class="lp-badge-ico"><i class="bx bxs-truck"></i></span><span><b>Livraison quotidienne</b><br />Grand Tunis &amp; Sousse</span></div>
          </div>
          <div class="lp-services-text">
            <span class="lp-kicker">Au service des pharmaciens</span>
            <h2>Le bon produit, au bon endroit, au bon moment.</h2>
            <p class="lp-lead">
              Nous accompagnons les officines et parapharmacies avec une offre complète et des services pensés
              pour simplifier leur quotidien et renforcer leur rentabilité.
            </p>
            <div class="lp-service-grid">
              <div v-for="s in services" :key="s.title" class="lp-service">
                <div class="lp-service-icon"><i :class="['bx', s.icon]"></i></div>
                <div><b>{{ s.title }}</b><span>{{ s.text }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Footer -->
      <footer class="lp-footer">
        <div class="lp-wrap">
          <div class="lp-footer-cta">
            <div>
              <h3>Une question sur une commande ?</h3>
              <p>Notre service client vous répond du lundi au samedi, de 8h à 17h.</p>
            </div>
            <div class="lp-footer-cta-btns">
              <a href="/claim" class="lp-btn lp-btn-white" @click.prevent="go('/claim')"><i class="bx bx-support"></i> Contacter le service client</a>
              <a href="/catalogue" class="lp-btn lp-btn-outline" @click.prevent="go('/catalogue')">Commander <i class="bx bx-right-arrow-alt"></i></a>
            </div>
          </div>

          <div class="lp-footer-grid">
            <div class="lp-footer-about">
              <a href="/" class="lp-footer-logo" @click.prevent="go('/')"><img src="/img/logo.png" alt="Grossiste Démo" /></a>
              <div class="lp-footer-brand">Grossiste Démo</div>
              <p>Grossiste répartiteur pharmaceutique et parapharmaceutique, au service des officines et des professionnels de santé.</p>
              <div class="lp-footer-badges">
                <span><i class="bx bxs-truck"></i> Livraison quotidienne</span>
                <span><i class="bx bx-lock-alt"></i> Espace sécurisé</span>
                <span><i class="bx bx-time-five"></i> Commande 24h/24</span>
              </div>
            </div>
            <div>
              <h5>Commander</h5>
              <a href="/catalogue" @click.prevent="go('/catalogue')">Catalogue</a>
              <a href="/catalogue" @click.prevent="go('/catalogue')">Saisie rapide</a>
              <a href="#actualites" @click.prevent="go('#actualites')">Promotions</a>
            </div>
            <div>
              <h5>Mon espace</h5>
              <a href="/commandes" @click.prevent="go('/commandes')">Commandes &amp; BL</a>
              <a href="/commandes" @click.prevent="go('/commandes')">Factures &amp; échéances</a>
              <a href="/reporting" @click.prevent="go('/reporting')">Rapports</a>
              <a href="/claim" @click.prevent="go('/claim')">Réclamations</a>
            </div>
            <div>
              <h5>Nos agences</h5>
              <span class="lp-footer-agency"><i class="bx bx-map"></i><span><b>Grand Tunis</b><br />Livraison matin et après-midi</span></span>
              <span class="lp-footer-agency"><i class="bx bx-map"></i><span><b>Sousse</b><br />Livraison quotidienne</span></span>
              <span class="lp-footer-agency"><i class="bx bx-time"></i><span>Lun – sam, 8h – 17h</span></span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </Layout>
</template>

<style scoped>
.lp { /* palette sampled from the login image (auth-back.jpg): pale blue-greys, sky blues, slate */
  --ink: #16352e; --ink2: #2b4a42; --mut: #5f7a72; --line: #e2ece8; --bg: #f4f9f7;
  --teal: #1b6e5a; --teal2: #2f9a7e; --indigo: #5fb39a; --pale: #e7f3ef; --pale2: #d3e7df;
  color: var(--ink); background: #fff; margin: 0; }
@media (min-width: 576px) { .lp { margin: 0 -12px; } }
.lp-wrap { max-width: 1240px; margin: 0 auto; padding: 0 24px; }

/* hero */
.lp-hero { position: relative; }
.lp-hero-img { width: 100%; height: 500px; object-fit: cover; display: block; }
.lp-hero-fallback { background: linear-gradient(120deg, var(--pale), var(--indigo)); }
.lp-carousel >>> .carousel-indicators { bottom: 84px; }
.lp-carousel >>> .carousel-indicators li { width: 26px; height: 4px; border-radius: 4px; border: 0; background: rgba(27,110,90,.30); }
.lp-carousel >>> .carousel-indicators .active { background: var(--teal); }
.lp-hero::after { content: ""; position: absolute; inset: 0; z-index: 1; pointer-events: none;
  background: linear-gradient(90deg, rgba(244,249,247,.96) 0%, rgba(231,243,239,.86) 40%, rgba(211,231,223,.25) 68%, rgba(211,231,223,0) 82%),
              linear-gradient(0deg, rgba(255,255,255,.85) 0%, rgba(255,255,255,0) 30%); }
.lp-hero-cap { position: absolute; inset: 0; z-index: 2; display: flex; flex-direction: column; justify-content: center;
  max-width: 1240px; margin: 0 auto; padding: 0 24px 60px; color: var(--ink); pointer-events: none; }
.lp-hero-cap > * { max-width: 640px; pointer-events: auto; }
.lp-glass { display: inline-flex; align-items: center; gap: 8px; align-self: flex-start; background: rgba(255,255,255,.75); backdrop-filter: blur(10px);
  border: 1px solid var(--pale2); color: var(--ink2); padding: 7px 14px; border-radius: 999px; font-size: 12.5px; font-weight: 600; margin-bottom: 20px; }
.lp-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--teal2); box-shadow: 0 0 0 4px rgba(47,154,126,.22); }
.lp-hero-cap h1 { color: var(--ink); font-size: 50px; line-height: 1.06; font-weight: 800; letter-spacing: -.035em; margin: 0 0 16px; }
.lp-grad { background: linear-gradient(90deg, #1b6e5a, #2f9a7e 55%, #5fb39a); -webkit-background-clip: text; background-clip: text; color: transparent; }
.lp-hero-cap p { color: var(--ink2); font-size: 18px; line-height: 1.55; margin: 0 0 28px; }
.lp-cta { display: flex; gap: 12px; flex-wrap: wrap; }
.lp-btn { display: inline-flex; align-items: center; gap: 8px; padding: 14px 24px; border-radius: 14px; font-weight: 600; font-size: 15px;
  transition: transform .15s, box-shadow .15s, background .15s, color .15s; }
.lp-btn i { font-size: 20px; transition: transform .15s; }
.lp-btn:hover i { transform: translateX(3px); }
.lp-btn-teal { background: linear-gradient(135deg, var(--teal2), var(--teal)); color: #fff; box-shadow: 0 12px 28px rgba(27,110,90,.30); }
.lp-btn-teal:hover { color: #fff; transform: translateY(-1px); }
.lp-btn-glass { background: #fff; color: var(--ink); border: 1px solid var(--pale2); }
.lp-btn-glass:hover { color: var(--teal); border-color: var(--teal2); }

/* quick access */
.lp-quick { position: relative; z-index: 3; margin-top: -70px; display: grid; grid-template-columns: repeat(6, 1fr); gap: 14px; }
.lp-quick-card { background: #fff; border: 1px solid #eef1f4; border-radius: 20px;  /* solid white: the translucent glass looked grey over the hero */
  padding: 20px 18px; display: flex; flex-direction: column; gap: 6px; color: var(--ink);
  box-shadow: 0 1px 2px rgba(22,53,46,.04), 0 16px 40px rgba(22,53,46,.10); transition: transform .2s, box-shadow .2s, border-color .2s; }
.lp-quick-card:hover { transform: translateY(-4px); border-color: var(--pale2); box-shadow: 0 22px 48px rgba(22,53,46,.14); color: var(--ink); }
.lp-quick-icon { width: 46px; height: 46px; border-radius: 14px; display: inline-flex; align-items: center; justify-content: center; font-size: 22px;
  background: var(--pale); color: var(--teal); margin-bottom: 8px; transition: background .2s, color .2s; }
.lp-quick-card:hover .lp-quick-icon { background: linear-gradient(135deg, var(--teal2), var(--teal)); color: #fff; }
.lp-quick-title { font-weight: 700; font-size: 15px; letter-spacing: -.01em; }
.lp-quick-text { font-size: 12.5px; color: var(--mut); line-height: 1.45; }

/* sections */
.lp-section { padding: 72px 0 8px; }
.lp-head { margin-bottom: 26px; }
.lp-kicker { color: var(--teal); font-weight: 700; font-size: 12px; text-transform: uppercase; letter-spacing: .14em; }
.lp-head h2, .lp-services-text h2 { font-size: 32px; font-weight: 800; color: var(--ink); margin: 8px 0 0; line-height: 1.15; letter-spacing: -.03em; }

/* news */
.lp-news { display: grid; grid-template-columns: repeat(3, 1fr); gap: 22px; }
.lp-news-card { background: #fff; border-radius: 22px; overflow: hidden; border: 1px solid var(--line); display: flex; flex-direction: column;
  box-shadow: 0 1px 2px rgba(22,53,46,.04), 0 10px 30px rgba(22,53,46,.05); transition: transform .2s, box-shadow .2s; }
.lp-news-card:hover { transform: translateY(-4px); box-shadow: 0 22px 44px rgba(22,53,46,.10); }
.lp-news-img { aspect-ratio: 16 / 9; overflow: hidden; background: #eef2f6; }
.lp-news-img img { width: 100%; height: 100%; object-fit: cover; transition: transform .5s; }
.lp-news-card:hover .lp-news-img img { transform: scale(1.05); }
.lp-news-body { padding: 20px 22px 24px; }
.lp-news-meta { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.lp-tag { font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em; padding: 4px 10px; border-radius: 999px; background: var(--pale); color: var(--teal); }
.lp-tag.t0 { background: #fdf2e9; color: #b4632a; } .lp-tag.t2 { background: #eef3f7; color: var(--ink2); }
.lp-date { font-size: 12px; color: var(--mut); }
.lp-news-body h3 { font-size: 17px; font-weight: 700; color: var(--ink); margin: 0 0 8px; line-height: 1.35; letter-spacing: -.01em; }
.lp-news-body p { font-size: 14px; color: var(--mut); margin: 0; line-height: 1.6;
  display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }

/* services */
.lp-services-bg { margin-top: 80px; padding: 88px 0;
  background: radial-gradient(800px 400px at 0% 0%, rgba(167,211,196,.28), transparent 60%),
              radial-gradient(700px 360px at 100% 100%, rgba(196,224,213,.35), transparent 60%), var(--bg); }
.lp-services { display: grid; grid-template-columns: 1fr 1.1fr; gap: 64px; align-items: center; }
.lp-services-img { position: relative; }
.lp-services-img img { width: 100%; border-radius: 26px; display: block; box-shadow: 0 30px 60px rgba(22,53,46,.18); }
.lp-badge { position: absolute; left: -20px; bottom: 30px; display: flex; gap: 12px; align-items: center; padding: 12px 18px 12px 12px;
  background: rgba(255,255,255,.9); backdrop-filter: blur(12px); border: 1px solid rgba(255,255,255,.7); border-radius: 16px;
  box-shadow: 0 16px 40px rgba(22,53,46,.18); font-size: 13px; color: var(--ink2); line-height: 1.4; }
.lp-badge-ico { width: 42px; height: 42px; border-radius: 12px; background: linear-gradient(135deg, var(--teal2), var(--teal)); color: #fff;
  display: flex; align-items: center; justify-content: center; font-size: 22px; }
.lp-lead { font-size: 16.5px; color: var(--mut); line-height: 1.7; margin: 18px 0 30px; }
.lp-service-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.lp-service { display: flex; gap: 14px; align-items: flex-start; background: #fff; border: 1px solid var(--line); border-radius: 18px; padding: 16px;
  transition: border-color .2s, box-shadow .2s; }
.lp-service:hover { border-color: var(--pale2); box-shadow: 0 12px 28px rgba(22,53,46,.07); }
.lp-service-icon { flex: 0 0 42px; height: 42px; border-radius: 12px; background: var(--pale); color: var(--teal);
  display: inline-flex; align-items: center; justify-content: center; font-size: 21px; }
.lp-service b { display: block; color: var(--ink); font-size: 14.5px; margin-bottom: 3px; }
.lp-service div > span { font-size: 13px; color: var(--mut); line-height: 1.5; }

/* stats */
.lp-stats { padding: 56px 0 96px; color: var(--ink);
  background: radial-gradient(700px 300px at 15% 0%, rgba(167,211,196,.55), transparent 60%),
              radial-gradient(600px 300px at 90% 100%, rgba(95,179,154,.35), transparent 60%), linear-gradient(180deg, #eaf5f0, #d7e9e1); }
.lp-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; text-align: center; }
.lp-stat { padding: 8px 0; border-left: 1px solid rgba(27,110,90,.15); }
.lp-stat:first-child { border-left: 0; }
.lp-stat-value { display: block; font-size: 42px; font-weight: 800; line-height: 1.1; letter-spacing: -.03em;
  background: linear-gradient(180deg, #1b6e5a, #16352e); -webkit-background-clip: text; background-clip: text; color: transparent; }
.lp-stat-label { color: var(--mut); font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: .1em; }

/* footer */
.lp-footer { margin-top: 0; padding: 56px 0 8px; color: #cfe3dc;
  background: radial-gradient(900px 360px at 0% 0%, rgba(47,154,126,.30), transparent 60%),
              radial-gradient(700px 320px at 100% 100%, rgba(95,179,154,.18), transparent 60%), #133a31; }
.lp-footer-cta { margin-bottom: 48px;  /* no overlap: sits inside the footer with space above and below */ display: flex; align-items: center; justify-content: space-between; gap: 24px; flex-wrap: wrap;
  padding: 26px 30px; border-radius: 22px; color: #fff;
  background: linear-gradient(120deg, var(--teal) 0%, var(--teal2) 100%); box-shadow: 0 20px 44px rgba(22,53,46,.25); }
.lp-footer-cta h3 { color: #fff; font-size: 21px; font-weight: 800; margin: 0 0 4px; letter-spacing: -.02em; }
.lp-footer-cta p { color: #e3f3ed; margin: 0; font-size: 14px; }
.lp-footer-cta-btns { display: flex; gap: 10px; flex-wrap: wrap; }
.lp-btn-white { background: #fff; color: var(--teal); }
.lp-btn-white:hover { color: var(--ink); box-shadow: 0 10px 22px rgba(0,0,0,.18); }
.lp-btn-outline { color: #fff; border: 1px solid rgba(255,255,255,.55); }
.lp-btn-outline:hover { color: var(--teal); background: #fff; }
.lp-footer-grid { display: grid; grid-template-columns: 1.9fr 1fr 1fr 1.2fr; gap: 40px; padding: 18px 0 34px; border-bottom: 1px solid rgba(255,255,255,.10); }
.lp-footer-logo { display: inline-flex; align-items: center; background: #fff; border-radius: 14px; padding: 10px 16px; margin-bottom: 16px;
  box-shadow: 0 8px 22px rgba(0,0,0,.18); transition: transform .15s; }
.lp-footer-logo:hover { transform: translateY(-2px); }
.lp-footer-grid a.lp-footer-logo { display: inline-flex; margin-bottom: 16px; }
.lp-footer-grid a.lp-footer-logo:hover { transform: translateY(-2px); }
.lp-footer-logo img { height: 40px; width: auto; display: block; }
.lp-footer-brand { font-size: 22px; font-weight: 800; letter-spacing: -.02em; margin-bottom: 10px; color: #fff; }
.lp-footer p { color: #a9c9be; font-size: 14px; line-height: 1.65; max-width: 380px; margin: 0 0 16px; }
.lp-footer-badges { display: flex; flex-wrap: nowrap; gap: 6px; }  /* the 3 badges on one line (user) */
.lp-footer-badges span { display: inline-flex; align-items: center; gap: 5px; font-size: 11.5px; font-weight: 600; color: #e3f3ed; white-space: nowrap;
  background: rgba(255,255,255,.07); border: 1px solid rgba(255,255,255,.12); padding: 4px 9px; border-radius: 999px; margin: 0; }
.lp-footer-badges i { color: #7fd0b6; font-size: 15px; }
.lp-footer h5 { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .12em; color: #fff; margin-bottom: 16px; }
.lp-footer-grid a { display: block; font-size: 14px; color: #a9c9be; margin-bottom: 10px; transition: color .15s, transform .15s; }
.lp-footer-grid a:hover { color: #fff; transform: translateX(2px); }
.lp-footer-agency { display: flex; gap: 10px; align-items: flex-start; font-size: 13.5px; color: #a9c9be; margin-bottom: 12px; line-height: 1.45; }
.lp-footer-agency i { color: #7fd0b6; font-size: 18px; margin-top: 1px; }
.lp-footer-agency b { color: #fff; }

/* entrance */
.lp-hero-cap > *, .lp-quick { animation: lp-rise .6s cubic-bezier(.2,.7,.2,1) both; }
.lp-hero-cap > :nth-child(2) { animation-delay: .05s; } .lp-hero-cap > :nth-child(3) { animation-delay: .1s; }
.lp-hero-cap > :nth-child(4) { animation-delay: .15s; } .lp-quick { animation-delay: .2s; }
@keyframes lp-rise { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: none; } }
@media (prefers-reduced-motion: reduce) { .lp-hero-cap > *, .lp-quick { animation: none; } }

/* responsive */
@media (max-width: 1199px) { .lp-quick { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 991px) {
  .lp-services { grid-template-columns: 1fr; gap: 40px; }
  .lp-news { grid-template-columns: 1fr 1fr; }
  .lp-stats-grid { grid-template-columns: 1fr 1fr; } .lp-stat:nth-child(3) { border-left: 0; }
}
@media (max-width: 767px) {
  .lp-hero-img { height: 460px; }
  .lp-hero-cap { justify-content: flex-end; padding-bottom: 96px; }
  .lp-hero-cap h1 { font-size: 32px; } .lp-hero-cap p { font-size: 15px; }
  .lp-quick { grid-template-columns: 1fr 1fr; margin-top: -48px; gap: 10px; }
  .lp-news { grid-template-columns: 1fr; } .lp-service-grid { grid-template-columns: 1fr; }
  .lp-badge { left: 12px; } .lp-footer-grid { grid-template-columns: 1fr 1fr; gap: 24px; } .lp-footer-about { grid-column: 1 / -1; }
  .lp-footer-cta { padding: 22px; margin-bottom: 32px; } .lp-footer-badges { flex-wrap: wrap; } .lp-footer { padding-top: 36px; }
  .lp-head h2, .lp-services-text h2 { font-size: 25px; }
}
</style>
